export default {
  "chooseLang": "Choose Your Language",
  "whatsOnMind": "What's on your mind?",
  "bestFood": "Best Food Outlets Near",
  "orderOnline": "Order Online",
  "dineout": "Dineout",
  "popularRestaurants": "Popular Order Food Online Restaurants Near me",
  "sortBy": "Sort By",
  "showMore": "SHOW MORE",
  "seeMore": "See More",
  "getApp": "Get the Waseeny App now!",
  "bestOffers": "For best offers and discounts curated specially for you.",
  "privacy": "Privacy Policy",
  "terms": "Terms & Conditions",
  "contact": "Contact Us",
  "setLocation": "Set Location",
  "locationDetected": "Location detected",
  "locationError": "Failed to detect location",
  "detecting": "Detecting",
  "searchPlaceholder": "Search for restaurants, dishes...",
  "food": "Food",
  "orderFoodFromRestaurants": "Order food from your favorite restaurants.",
  "exploreNow": "Explore Now",
  "discoverFoodTitle": "Discover Delicious Food Delights Online Near You",
  "discoverFoodText": "Craving something delicious? Discover a world of culinary delights right at your fingertips with food delivery near me! Whether you're in the mood for a hearty burger, fresh sushi, or a comforting bowl of pasta, there's no shortage of options to satisfy your cravings. The convenience of online food delivery near me allows you to explore various restaurants and cuisines without leaving the comfort of your home...",
  "allRightsReserved": "All rights reserved.",
  "logout": "Logout",
  "min": "min",
  "loading": "Loading...",
  "error": "Error",
  "enterSearchTerm": "Please enter a search term",
  "welcomeBack": "Welcome Back!",
  "loginSubtitle": "Log in to continue your meal journey",
  "emailLabel": "Email",
  "passwordLabel": "Password",
  "emailPlaceholder": "Enter your email",
  "passwordPlaceholder": "Enter your password",
  "forgotPassword": "Forgot password?",
  "loggingIn": "Logging in...",
  "continueWithGoogle": "Continue with Google",
  "dontHaveAccount": "Don't have an account?",
  "signUp": "Sign up",
  "searchFoodPlaceholder": "Search for restaurant and food",
  "signIn": "Sign In",
  "viewCart": "View Cart",
  "home": "Home",
  "cityName": "City name",
  "delivery": "Delivery",
  "freeDeliveryPromo": "Free delivery for first order",
  "minOrder": "Min order",
  "change": "Change",
  "dineOutAvailable": "Dine Out Available",
  "reserveTableNow": "Reserve your table now",
  "callForReservations": "Call for reservations",
  "reserveTable": "Reserve Table",
  "dealsForYou": "Deals For You",
  "extraOff": "Extra 0.50 Off",
  "noCodeRequired": "No Code Required | Above 5",
  "searchDishesPlaceholder": "Search For Dishes",
  "popular": "Popular",
  "mostOrdered": "Most Order right now",
  "itemInCart": "Item in Cart",
  "itemsInCart": "Items in Cart",
  "itemAdded": "Item added to cart!",
  "failedToAdd": "Failed to add item to cart. Please try again.",
  "cartEmpty": "Your cart is empty",
  "add": "ADD",
  "selectDeliveryAddress": "Select delivery address",
  "savedAddressFound": "You have a saved address in this location",
  "addNewAddress": "Add New Address",
  "addressType": "Address Type",
  "homeType": "Home",
  "workType": "Work",
  "otherType": "Other",
  "addressPlaceholder": "Enter your complete address (e.g., House No., Building Name, Street, Area)",
  "instructionsPlaceholder": "Delivery instructions (optional - e.g., Ring doorbell twice)",
  "confirmAddress": "Confirm Address",
  "deliveryAddress": "Delivery Address",
  "cityLabel": "City",
  "minDelivery": "min delivery",
  "changeUpper": "CHANGE",
  "choosePaymentMethod": "Choose payment method",
  "proceedToPay": "Proceed to Pay",
  "billDetails": "Bill Details",
  "subtotal": "Subtotal",
  "standardDelivery": "Standard Delivery",
  "free": "Free",
  "serviceFee": "Service Fee",
  "offerApplied": "Offer Applied",
  "off": "Off",
  "grandTotal": "Grand Total",
  "searchingFor": "Searching for",
  "resultsFor": "Results for",
  "noMatchesFound": "No matches found for",
  "backToHome": "Back to Home",
  "restaurants": "Restaurants",
  "freeDelivery": "Free Delivery",
  "products": "Products",
  "itemsAddedToCart": "Item(s) Added",
  "deliveryIn": "Delivery In",
  "orderSummary": "Order Summary",
  "noItemsInCart": "No items in cart",
  "payByUpi": "Pay by UPI App",
  "addNewUpi": "Add New UPI ID",
  "upiSubtitle": "You need to have a registered UPI ID",
  "creditDebitCard": "Credit & Debit Card",
  "addNewCard": "Add New Card",
  "savePayCards": "Save & Pay via Cards",
  "morePaymentOptions": "More Payment Options",
  "phonePeGPay": "PhonePe, G Pay & More",
  "netBanking": "Net Banking",
  "selectBanks": "Select From a list Banks",
  "payOnDelivery": "Pay on delivery",
  "codTitle": "Cash on Delivery ( Cash / UPI )",
  "payOnReceive": "Pay when you receive your food",
  "placingOrder": "Placing Order...",
  "waitConfirmOrder": "Please wait while we confirm your order.",
  "waitProcessPayment": "Please wait while we process your payment via",
  "orderConfirmed": "Order Confirmed",
  "orderConfirmedMessage": "Your order has been successfully confirmed! We are currently processing it and will provide updates on the status shortly.",
  "viewBookingDetails": "View Booking Details",
  "exploreOtherMenu": "Explore Other Menu",
  "cartEmptyAlert": "Cart is empty. Please add items first.",
  "resetPassword": "Reset Password",
  "verifyOtp": "Verify OTP",
  "enterEmailReset": "Enter your email to reset your password",
  "enterOtpMobile": "Enter OTP sent to your mobile",
  "enterNewPassword": "Enter your new password",
  "passwordResetSubSuccess": "Your password has been reset",
  "sending": "Sending...",
  "sendOtp": "Send OTP",
  "enterOtpLabel": "Enter OTP",
  "verifying": "Verifying...",
  "resendOtpIn": "Resend OTP in",
  "resendOtpBtn": "Resend OTP",
  "newPasswordPlaceholder": "Enter new password",
  "resetting": "Resetting...",
  "passwordResetSuccessMsg": "Your password has been successfully reset. You can now login with your new password.",
  "backToLogin": "Back to Login",
  "back": "Back",
  "passLengthError": "Password must be at least 6 characters",
  "passMatchError": "Passwords do not match",
  "orderPlacedOn": "Order placed on",
  "more": "More",
  "reorder": "Reorder",
  "preparing": "Preparing",
  "ongoing": "Ongoing",
  "delivered": "Delivered",
  "orderPlacedSuccess": "Your order has been successfully placed",
  "orderIdLabel": "Order ID",
  "totalAmountLabel": "Total Amount",
  "statusLabel": "Status",
  "trackOrder": "Track Order",
  "redirectingToTracking": "Redirecting to tracking in",
  "seconds": "seconds",
  "secureCheckout": "Secure Checkout",
  "safePayment": "Secure Payment",
  "help": "Help",
  "account": "Account",
  "paymentMethods": "Payment Methods",
  "items": "Items",
  "total": "Total",
  "onlinePaymentStripe": "Online Payment (Stripe)",
  "cardSubtitle": "Visa, Mastercard, Maestro",
  "giropaySubtitle": "Pay directly from your bank account",
  "klarnaSubtitle": "Pay now or later",
  "barzahlung": "Cash on Delivery",
  "doorstepPayment": "Pay at the doorstep",
  "selected": "Selected",
  "payNow": "Order and pay",
  "processingTitle": "Processing...",
  "okayOrderLater": "Okay, I'll order later",
  "restaurantClosed": "Restaurant Currently Closed",
  "moreItems": "more items",
  "pleaseLogInToOrder": "Please log in to place your order",
  "loginRequiredForOrder": "You need to have an account to save your delivery address and securely complete the payment.",
  "logInOrCreateAccount": "Log In or Create Account",
  "cartConflictMessage": "Your cart contains items from another restaurant. Do you want to clear your cart and add this item?",
  "adding": "Adding",
  "toCart": "to Cart",
  "Call number not available": "Call number not available",
  "Restaurant phone number not available": "Restaurant phone number not available",
  ",": ",",
  "Please fill all mandatory fields and select a location on the map.": "Please fill all mandatory fields and select a location on the map.",
  "Failed to save address. Please try again.": "Failed to save address. Please try again.",
  "Rider phone number not available.": "Rider phone number not available.",
  "enterEmailError": "Please enter your email address",
  "enterValidEmailError": "Please enter a valid email address",
  "enterPasswordError": "Please enter your password",
  "enterOtpError": "Please enter the OTP",
  "enterNewPassError": "Please enter a new password",
  "enterEmailPlaceholder": "Enter your email",
  "newPassword": "New Password",
  "confirmPasswordLabel": "Confirm Password",
  "confirmNewPasswordPlaceholder": "Confirm your new password",
  "Token not received from backend": "Token not received from backend",
  "Invalid email or password": "Invalid email or password",
  "Google login token missing. Please try clicking the Google button again.": "Google login token missing. Please try clicking the Google button again.",
  "Something went wrong with Google Login": "Something went wrong with Google Login",
  "getStarted": "Sign In",
  "or": "or",
  "No contact number available at the moment.": "No contact number available at the moment.",
  "Reason for cancellation?": "Reason for cancellation?",
  "Order cancelled successfully": "Order cancelled successfully",
  "Why are you requesting a refund?": "Why are you requesting a refund?",
  "Refund request submitted successfully. Admin will review it shortly.": "Refund request submitted successfully. Admin will review it shortly.",
  "session_id": "session_id",
  "Thank you for your rating!": "Thank you for your rating!",
  "Please select at least one item or provide a note for the refund.": "Please select at least one item or provide a note for the refund.",
  "Failed to reorder items. Please try again.": "Failed to reorder items. Please try again.",
  "Maximum 6 images are allowed.": "Maximum 6 images are allowed.",
  "reordering": "reordering",
  "Delivery address is missing. Please go back to checkout.": "Delivery address is missing. Please go back to checkout.",
  "Failed to add address": "Failed to add address",
  "Failed to delete address": "Failed to delete address",
  "Failed to select address": "Failed to select address",
  "Please enter a valid 6-digit OTP": "Please enter a valid 6-digit OTP",
  "Account deletion request submitted. Our team will contact you for verification.": "Account deletion request submitted. Our team will contact you for verification.",
  "Add money feature coming soon!": "Add money feature coming soon!",
  "oftenOrderedWith": "Often ordered with",
  "completeMeal": "Complete your meal",
  "loginRequired": "Login Required",
  "loginRequiredSub": "Please log in to continue.",
  "logInNow": "Log in now",
  "cancel": "Cancel",
  "q": "q",
  "-": "-",
  "recentSearches": "Recent Searches",
  "clear": "Clear",
  "pureVeg": "Pure Veg",
  "rating": "Rating",
  "anyPrice": "Any Price",
  "Please enter a valid amount": "Please enter a valid amount",
  "Please enter your Bank User ID": "Please enter your Bank User ID",
  "Bank transaction failed. Please check your bank status.": "Bank transaction failed. Please check your bank status.",
  "canvas": "canvas",
  "2d": "2d",
  "link": "link",
  "locality": "locality",
  "administrative_area_level_2": "administrative_area_level_2",
  "administrative_area_level_1": "administrative_area_level_1",
  "country": "country",
  "postal_code": "postal_code",
  "route": "route",
  "sublocality_level_1": "sublocality_level_1",
  "sublocality": "sublocality",
  "street_number": "street_number",
  "Checkout": "Checkout",
  "Choose a saved address or add a new one": "Choose a saved address or add a new one",
  "DEFAULT": "DEFAULT",
  "Change Map Location": "Change Map Location",
  "Select Location on Map": "Select Location on Map",
  "Selected Location:": "Selected Location:",
  "House / Flat No.": "House / Flat No.",
  "e.g. Flat 101": "e.g. Flat 101",
  "Street / Area": "Street / Area",
  "e.g. Main Street": "e.g. Main Street",
  "Landmark (Optional)": "Landmark (Optional)",
  "e.g. Near Apollo Hospital": "e.g. Near Apollo Hospital",
  "Save As": "Save As",
  "Saving...": "Saving...",
  "Save Address": "Save Address",
  "Cancel": "Cancel",
  "Available Offers & Coupons": "Available Offers & Coupons",
  "Loading offers...": "Loading offers...",
  "APPLIED": "APPLIED",
  "APPLY": "APPLY",
  "No coupons available right now.": "No coupons available right now.",
  "Item Total": "Item Total",
  "Delivery Fee": "Delivery Fee",
  "Platform Fee": "Platform Fee",
  "Tax": "Tax",
  "Packaging": "Packaging",
  "Small Cart Fee": "Small Cart Fee",
  "Surge Fee": "Surge Fee",
  "Tip": "Tip",
  "Discount": "Discount",
  "Please log in for order": "Please log in for order",
  "Remove item": "Remove item",
  "No Max Limit": "No Max Limit",
  "Up to": "Up to",
  "OFF": "OFF",
  "Special offer for you!": "Special offer for you!",
  "Apna Resto": "Apna Resto",
  "Near": "Near",
  "Select City": "Select City",
  "Choose a city...": "Choose a city...",
  "Loading cities...": "Loading cities...",
  "No cities available": "No cities available",
  "Address not specified": "Address not specified",
  "Order failed": "Order failed",
  "Loading Payment details...": "Loading Payment details...",
  "100% Secure Transaction": "100% Secure Transaction",
  "Debit/Credit Card / KLARNA": "Debit/Credit Card / KLARNA",
  "Secure payment via Stripe": "Secure payment via Stripe",
  "Select Payment Method": "Select Payment Method",
  "Order Tracking": "Order Tracking",
  "Help": "Help",
  "No orders found.": "No orders found.",
  "Rate your Experience": "Rate your Experience",
  "Tell us more about the food and delivery...": "Tell us more about the food and delivery...",
  "Submitting...": "Submitting...",
  "Submit Rating": "Submit Rating",
  "Request Item-Level Refund": "Request Item-Level Refund",
  "Select the items that had issues and provide details.": "Select the items that had issues and provide details.",
  "No specific items found. Full order refund will be requested.": "No specific items found. Full order refund will be requested.",
  "Additional Note / Reason": "Additional Note / Reason",
  "Describe the issue in detail...": "Describe the issue in detail...",
  "Evidence Images (Optional, Max 6)": "Evidence Images (Optional, Max 6)",
  "Click to select photos": "Click to select photos",
  "Supports PNG, JPG, JPEG (Max 6 files)": "Supports PNG, JPG, JPEG (Max 6 files)",
  "Submit Refund": "Submit Refund",
  "Rate Order": "Rate Order",
  "Refund Request": "Refund Request",
  "cancelled": "Cancelled",
  "Profile": "Profile",
  "Menu": "Menu",
  "Call Rider": "Call Rider",
  "Call Restaurant": "Call Restaurant",
  "Your food is being prepared fresh!": "Your food is being prepared fresh!",
  "Paid Amount": "Paid Amount",
  "Hurray! You saved": "Hurray! You saved",
  "on this order": "on this order",
  "Track": "Track",
  "Payment Method": "Payment Method",
  "Payment Details": "Payment Details",
  "On": "On",
  "at": "at",
  "Cancel Order": "Cancel Order",
  "Failed to request refund": "Failed to request refund",
  "Re-request Refund": "Re-request Refund",
  "Report Problem / Request Refund": "Report Problem / Request Refund",
  "Refund Request Pending Admin Approval": "Refund Request Pending Admin Approval",
  "Refund Completed": "Refund Completed",
  "orders": "Orders",
  "topBrandsIn": "Top Brands in",
  "yourArea": "Your Area",
  "filters": "Filters",
  "fastDelivery": "Fast Delivery",
  "offers": "Offers",
  "openNow": "Open Now",
  "sortRelevance": "Sort: Relevance",
  "sortDeliveryTime": "Sort: Delivery Time",
  "sortRating": "Sort: Rating",
  "sortCostLowToHigh": "Sort: Cost ↑",
  "sortCostHighToLow": "Sort: Cost ↓",
  "noRestaurantsMatchFilters": "No restaurants match your filters",
  "clearFilters": "Clear Filters",
  "noRestaurantsNearby": "No restaurants available nearby",
  "noRestaurantsNearbyDesc": "We could not find any restaurants near your current location right now. Try changing your location or check back in a while.",
  "Filters & Sorting": "Filters & Sorting",
  "quickFilters": "Quick Filters",
  "fastDeliveryLimit": "Fast Delivery (<30 min)",
  "offersBogoFree": "Offers (BOGO, Free Delivery)",
  "Pure Veg": "Pure Veg",
  "Open Now": "Open Now",
  "newRestaurants": "New Restaurants",
  "4.5+": "4.5+",
  "4.0+": "4.0+",
  "foodType": "Food Type",
  "Veg": "Veg",
  "Non-Veg": "Non-Veg",
  "Vegan": "Vegan",
  "costRange": "Cost Range",
  "Low (₹)": "Low (₹)",
  "Medium (₹₹)": "Medium (₹₹)",
  "High (₹₹₹)": "High (₹₹₹)",
  "clearAll": "Clear All",
  "applyFilters": "Apply Filters",
  "Relevance": "Relevance",
  "Delivery Time": "Delivery Time",
  "Rating": "Rating",
  "Cost Low to High": "Cost Low to High",
  "Cost High to Low": "Cost High to Low",
  "exclusiveDeals": "EXCLUSIVE DEALS",
  "todaysOffers": "Today's Offers",
  "trendingThisWeek": "Trending This Week",
  "whyChooseWaseeny": "Why Choose Waseeny?",
  "fastestDelivery": "Fastest Delivery",
  "fastestDeliveryDesc": "Get your food delivered in minutes, fresh and hot.",
  "securePayments": "Secure Payments",
  "securePaymentsDesc": "We accept online payment methods.",
  "qualityFood": "Top Quality Food",
  "qualityFoodDesc": "Partnered with the best restaurants to ensure quality.",
  "noTrendingRestaurants": "No trending restaurants found.",
  "dish": "Dish",
  "Please select or add a delivery address first.": "Please select or add a delivery address first.",
  "Browse Restaurants": "Browse Restaurants",
  "Please provide your delivery location details": "Please provide your delivery location details",
  "Back to Saved Addresses": "Back to Saved Addresses",
  "Other": "Other",
  "Please describe the reason": "Please describe the reason",
  "all": "All",
  "whatOurCustomersSay": "What our customers say",
  "forABetterExperience": "For a better experience",
  "downloadTheWaseenyApp": "Download the Waseeny app",
  "getYourFoodDelivered": "Get your food delivered fast, track your order live and enjoy exclusive app offers.",
  "Failed to cancel order": "Failed to cancel order",
  "Chat with Rider": "Chat with Rider",
  "Items": "Items",
  "Refund Approved & Credited to Wallet": "Refund Approved & Credited to Wallet",
  "Refund Request Submitted - Pending Admin Review": "Refund Request Submitted - Pending Admin Review",
  "Something went wrong.": "Something went wrong.",
  "Refund request failed": "Refund request failed",
  "Missing Item": "Missing Item",
  "Quality Issue / Burnt": "Quality Issue / Burnt",
  "Spill / Damaged": "Spill / Damaged",
  "Wrong Item": "Wrong Item",
  "Late Delivery": "Late Delivery",
  "Online card payment is unavailable until Stripe is configured. Please choose cash on delivery or contact support.": "Online card payment is unavailable until Stripe is configured. Please choose cash on delivery or contact support.",
  "Card payment is unavailable until Stripe is configured.": "Card payment is unavailable until Stripe is configured.",
  "deliveryTime": "Delivery time",
  "distance": "Distance",
  "deliveryFee": "Delivery fee",
  "supportContactMessage": "Support is available 24/7. Email us at {email} or call {phone}.",
  "exploreCollections": "Explore Collections",
  "supportContactEmailOnly": "Support is available 24/7. Email us at {email}.",
  "supportContactPhoneOnly": "Support is available 24/7. Call us at {phone}.",
  "supportContactNone": "Support is available 24/7. Use Contact Support in your profile to message us.",
  "Cuisines": "Cuisines",
  "outOfDeliveryArea": "Sorry, we don't deliver to this address yet.",
  "Delivery": "Delivery",
  "Pick-up": "Pick-up",
  "Pick up at": "Pick up at",
  "Pay online now and show your pick-up code at the counter.": "Pay online now and show your pick-up code at the counter.",
  "Pick-up orders are paid online.": "Pick-up orders are paid online.",
  "Could not change delivery option. Please try again.": "Could not change delivery option. Please try again.",
  "No longer available": "No longer available",
  "Your cart already has items. Replace them with this order?": "Your cart already has items. Replace them with this order?",
  "Reorder": "Reorder",
  "Reordering...": "Reordering...",
  "Remove this card?": "Remove this card?",
  "Saved cards": "Saved cards",
  "No saved cards yet.": "No saved cards yet.",
  "Tick \"save card\" when you pay by card at checkout. Cards are stored securely by Stripe.": "Tick \"save card\" when you pay by card at checkout. Cards are stored securely by Stripe.",
  "Expires": "Expires",
  "Remove": "Remove",
  "Allergens": "Allergens",
  "No allergens declared - ask the restaurant if you have an allergy.": "No allergens declared - ask the restaurant if you have an allergy.",
  "Download invoice (PDF)": "Download invoice (PDF)",
  "Downloading...": "Downloading...",
  "Could not download the invoice. Please try again.": "Could not download the invoice. Please try again.",
  "Distance": "Distance",
  "Within": "Within",
  "Cuisine": "Cuisine",
  "Any cuisine": "Any cuisine",
  "Any distance": "Any distance",
  "Tip your rider": "Tip your rider",
  "100% of the tip goes to your rider": "100% of the tip goes to your rider",
  "Not now": "Not now",
  "Could not update the tip. Please try again.": "Could not update the tip. Please try again.",
  "Share this code with your delivery partner to receive your order": "Share this code with your delivery partner to receive your order",
  "orderLegalPre": "By placing your order you agree to our",
  "orderLegalMid": "and acknowledge our",
  "orderLegalPost": ".",
  "imprint": "Imprint",
};